import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { validationMessagesMap } from 'src/utils/messages';
import { formatResourcePath } from 'src/utils/regex';

import type { GuestReason } from 'src/features/parkingManagement/api/ReasonsForGuest/useGetParkingGuestReasons';

const RESOURCE = '/parkings/:parkingId/parking-guest-reason/';

export type CreateParkingGuestReasonFnType = typeof createParkingGuestReason;
type FormSchemaValues = z.infer<typeof formSchema>;

export const formSchema = z.object({
    name: z.string({ message: validationMessagesMap.validationErrorRequired }),
});

export type DTO = {
    parkingId: string;
    name?: string;
};

const createParkingGuestReason = ({ parkingId, ...data }: DTO): Promise<GuestReason> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseCreateParkingGuestReasonOptions
    extends MutationConfig<CreateParkingGuestReasonFnType, GeneralSmartParkError> {}

export const useCreateParkingGuestReason = (options: UseCreateParkingGuestReasonOptions) =>
    useMutation({
        mutationFn: createParkingGuestReason,
        ...options,
    });

export { formSchema as createParkingGuestReasonFormSchema };
export type { FormSchemaValues as CreateParkingGuestReasonFormSchemaValues };
